import { makeStyles } from '@mui/styles';
import Typography from '@classify/react-core-components/Typography';
import { translate } from '@openclassrooms/translations';

import StartNowButton from '../StartNowButton';
import ContinueCourseButton from '../ContinueCourseButton';
import FollowCourseButton from '../FollowCourseButton';
import UnfollowCourseButton from '../UnfollowCourseButton';
import useCourseStatus from '../../hooks/useCourseStatus';

const useStyles = makeStyles(
  ({ breakpoints, spacing }) => ({
    row: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    actions: {
      marginLeft: 'auto',
      marginRight: 'auto',
      [breakpoints.up('sm')]: {
        marginLeft: 'revert',
      },
      [breakpoints.up('md')]: {
        marginLeft: spacing(3),
      },
    },
    hstack: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      '& > * + *': {
        marginTop: spacing(2),
      },
      [breakpoints.up('sm')]: {
        flexDirection: 'row',
        '& > * + *': {
          marginTop: 'unset',
          marginLeft: spacing(4),
        },
      },
    },
  }),
  { classNamePrefix: 'HeroAction' }
);

function HeroAction() {
  const classes = useStyles();
  const { isFinished, hasAlreadyFollowed, notStarted, isFollowing } = useCourseStatus();

  if (isFinished) {
    return null;
  }

  if (hasAlreadyFollowed) {
    return <FollowCourseButton>{translate('course.reenroll.button')}</FollowCourseButton>;
  }

  if (notStarted) {
    return (
      <div className={classes.row}>
        <Typography
          variant="subheading"
          component="span"
          sx={{ display: { xs: 'none', md: 'block' } }}
        >
          {translate('course.header.incentive')}
        </Typography>
        <div className={classes.actions}>
          <StartNowButton />
        </div>
      </div>
    );
  }

  if (isFollowing) {
    return (
      <div className={classes.hstack}>
        <div>
          <ContinueCourseButton />
        </div>
        <div>
          <UnfollowCourseButton />
        </div>
      </div>
    );
  }

  return null;
}

export default HeroAction;
